import React, { useState } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import './Accordion.scss';

const Accordion = ({ title, content }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="accordion-item">
      <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
        <div className="title">{title}</div>
        <div className="icon">{isActive ? '-' : '+'}</div>
      </div>
      {isActive && <div className="accordion-content">{documentToReactComponents(JSON.parse(content))}</div>}
    </div>
  );
};

export default Accordion;